import vocie_icon from './main.vue'
vocie_icon.install = function (vue) {
  vue.component(vocie_icon.name, vocie_icon)
}
export default vocie_icon



// WEBPACK FOOTER //
// ./src/ui/components/voice_icon/index.js